import styled from '@emotion/styled';
import { Button } from '@anyroad/button';
import { colors, brandNeutralColors } from '@anyroad/theme';

export const PageContainer = styled.div`
  &.CheckoutPage {
    &.CheckoutMobileFirstPage {
      @media (max-width: 767px) {
        padding: 0;
      }
    }

    &.is-live {
      background: ${colors.white};
    }
  }
`;

export const SummaryWrapper = styled.div`
  @media (max-width: 767px) {
    display: block;
    margin-bottom: 20px;
    padding: 0;
  }

  @media (min-width: 768px) {
    display: block;
    order: 2;
  }
`;

export const ColumnContainer = styled.div`
  &.MobileFirstColumnContainer {
    @media (min-width: 768px) {
      display: flex;
      gap: 20px;
      max-width: 1200px;
      margin: 0 auto;
    }
  }
`;

export const ComponentContainer = styled.div`
  &.ComponentContainer {
    padding: 20px;

    @media (min-width: 768px) {
      flex: 1;
    }

    &.MobileFirstColumn {
      @media (min-width: 768px) {
        order: 1;
      }
    }

    &.MobileFirstSummaryColumn {
      @media (min-width: 768px) {
        max-width: 400px;
      }
    }
  }
`;

export const LiveBookingHeader = styled.div`
  margin-bottom: 20px;

  h3 {
    margin-bottom: 8px;
  }

  p {
    color: ${colors.text.secondary};
  }
`;

export const AffiliateFreeBookingMessage = styled.div`
  padding: 20px;
  background: ${brandNeutralColors.background.light};
  border-radius: 8px;
  margin-bottom: 20px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 30px;
  margin-bottom: 20px;
`;

export const SubmitButton = styled(Button)`
  &.loading {
    position: relative;
    color: transparent;

    &::after {
      content: '';
      position: absolute;
      width: 16px;
      height: 16px;
      top: 50%;
      left: 50%;
      border-top-color: transparent;
      animation: spin 0.6s linear infinite;
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ConfirmationContainer = styled.div`
  &.ConfirmationContainer {
    text-align: center;
    padding: 20px;

    &.is-live {
      background: ${colors.white};
    }
  }
`;

export const PaymentSubtext = styled.div`
  &.payment-subtext {
    margin-bottom: 20px;
    color: ${colors.text.secondary};
  }

  &.contains-brand-link {
    a {
      color: var(--brand-color, ${colors.error});
    }
  }
`;

export const ConfirmationSubtext = styled.p`
  &.hint {
    color: ${colors.text.secondary};
    font-size: 14px;
    margin-top: 10px;
  }

  &.confirmation-subtext {
    margin-bottom: 20px;
  }
`;
